import { forwardRef } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import {
  type TAccordionContentElement,
  type TAccordionContentProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import { cn } from "@/ui/lib/utils";

export const AccordionContent = forwardRef<TAccordionContentElement, TAccordionContentProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <AccordionPrimitive.Content
      data-component="AccordionContent"
      ref={ref}
      className={cn(
        "overflow-hidden text-sys-sm text-foreground-muted-strong",
        "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        className,
      )}
      {...props}
    >
      <div className="px-4 py-1 flex flex-col gap-2">
        { children }
      </div>
    </AccordionPrimitive.Content>
  ),
);

AccordionContent.displayName = AccordionPrimitive.Content.displayName;
